import { render } from "./JitsiIframe.vue?vue&type=template&id=09a4658a"
import script from "./JitsiIframe.vue?vue&type=script&lang=js"
export * from "./JitsiIframe.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\user\\WebstormProjects\\wisevet-live\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__